import React from 'react';
import { usePagination, DOTS } from '../hooks/usePagination';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import styles from '../../_css/SecurityCompliance.module.css';

const Pagination = ({
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className
}) => {
    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    // If there are less than 2 times in pagination range we shall not render the component
    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    let lastPage = paginationRange[paginationRange.length - 1];

    return (
        <div className={`${styles.paginationContainer} ${className}`}>
            <div className={styles.paginationContent}>
                {/* Previous Button */}
                <button
                    className={`${styles.paginationButton} ${styles.paginationButtonPrev}`}
                    disabled={currentPage === 1}
                    onClick={onPrevious}
                >
                    <ChevronLeft size={16} />
                    Previous
                </button>

                {/* Page Numbers */}
                <div className={styles.pageNumbers}>
                    {paginationRange.map((pageNumber, index) => {
                        if (pageNumber === DOTS) {
                            return <span key={index} className="px-3 py-2">...</span>;
                        }

                        return (
                            <button
                                key={index}
                                className={`${styles.pageNumberButton} ${pageNumber === currentPage ? styles.pageNumberButtonActive : ''
                                    }`}
                                onClick={() => onPageChange(pageNumber)}
                            >
                                {String(pageNumber).padStart(2, '0')}
                            </button>
                        );
                    })}
                </div>

                {/* Next Button */}
                <button
                    className={`${styles.paginationButton} ${styles.paginationButtonNext}`}
                    disabled={currentPage === lastPage}
                    onClick={onNext}
                >
                    Next
                    <ChevronRight size={16} />
                </button>
            </div>
        </div>
    );
};

export default Pagination;